import { findTenantConfigContent } from './globalFollowSettings';

export const TIME_ZONE_CONFIG_KEY = 'timeZone';

export const DEFAULT_TIME_ZONE_CONFIG = {
  timeZone: '+08:00',
  dateFormat: 'yyyy-MM-dd',
  timeFormat: '24h',
  useBrowserTimezone: false,
};

function toBoolean(value, defaultValue) {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'number') {
    return value === 1;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true' || normalized === '1') {
      return true;
    }
    if (normalized === 'false' || normalized === '0') {
      return false;
    }
  }
  return Boolean(value);
}

/**
 * 從 tenant_config.timeZone 解析前台日期／時間顯示設定。
 */
export function normalizeTimeZoneConfig(content) {
  const source = content && typeof content === 'object' ? content : {};
  const timeFormat = source.timeFormat === '12h' ? '12h' : '24h';
  const dateFormat = source.dateFormat === 'dd-MM-yyyy' ? 'dd-MM-yyyy' : 'yyyy-MM-dd';
  return {
    timeZone: source.timeZone || DEFAULT_TIME_ZONE_CONFIG.timeZone,
    dateFormat,
    timeFormat,
    useBrowserTimezone: toBoolean(
      source.useBrowserTimezone,
      DEFAULT_TIME_ZONE_CONFIG.useBrowserTimezone
    ),
  };
}

export function pickTimeZoneConfigFromTenantList(list) {
  return normalizeTimeZoneConfig(findTenantConfigContent(list, TIME_ZONE_CONFIG_KEY));
}
